module.exports = __webpack_public_path__ + "static/media/nima_walking_2s.eecfc9ee.gif";